(function (ws, win) {
    'use strict';
    ws.views.quoteConversionOrder = ws.views.form.extend({
        errorMsg: '.error-message',

        /**
         * Google Analytics Variables
         */
        GTM_EVENT_CATEGORY: 'quote_activity',
        GTM_EVENT_ACTION: 'attach_po',
        GTM_EVENT_OPTIONAL_FILE_ACTION: 'attach_optional_files',
        GTM_EVENT_SUBMIT_ORDER_ACTION: 'submit_order',

        /**
         * Events override
         */
        events: _.extend({}, ws.views.form.prototype.events, {
            'change .upload': 'verifyFile',
            'change .file-upload': 'verifyPOFileUpload',
            'click .file-upload': 'confirmUpload',
            'click .icon-trash': 'deleteFile',
            'change #terms': 'termsValidation',
            'blue #poNumber': 'validatePoNumber',
            'keyup #poNumber': 'validatePoNumber'
        }),

        /**
         * Initialize
         */
        initialize: function () {
            //globals
            this.$errors = this.$('.cqc-error');
            this.cqcFileTypes = 'application/vnd.ms-excel, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document,  application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            this.cqcExtensions = 'xls, pdf, doc, docx, xlsx';

            //file upload form
            this.$uploadFile = this.$('.qc-upload-cont');
            this.$uploadInput = this.$('.upload')[0];
            this.$uploadPOInput = this.$('.file-upload')[0];
            this.$fileName = this.$('.cqc-file-name');
            this.$poFileName = this.$('.cqc-po-file-name');
            this.$siteFromName = this.$('.siteDiferenceId').val();

            if (this.$siteFromName.startsWith('westcon')) {
                this.$siteFromName = 'westcon';
            }

            //errors additional file
            this.$fileUploadFormatError = this.$('.cqc-file-upload-format-error');
            this.$fileSameError = this.$('.cqc-file-same-file-error');
            this.$cqcErrors = this.$('.cqc-error');

            //PO file errors
            this.$cqcPoErrors = this.$('.cqc-po-error');
            this.$filePoSameError = this.$('.cqc-po-file-same-file-error');
            this.$filePoFileTypeError = this.$('.cqc-po-error-filetype');
            this.$fileUploadError = this.$('.cqc-file-upload-error');

            this.$termsError = this.$('.cqc-terms-error');
            this.$globalMessage = this.$('#globalerror');
            this.$cloudOrderSuccess = this.$('#cloudError');
            this.genericErrorMessage = this.$globalMessage.html();
            this.$saveButton = this.$('.cqc-upload-submit');
            this.$uploadFileTpl = _.template($('#uploadFileNameTpl').html());
            this.uid = this.$el.data('uid');

            // site shares endpoints
            if (!(this.uid === 'quoting' || this.uid === 'orderentry' || this.uid === 'westcon') && this.uid.startsWith('westcon')) {
                this.uid = 'westcon';
            }

            this.$checkTerms = this.$('#terms');

            //final list of files user will send to BE
            this.fileList = [];

            //modals
            this.$cqcForm = this.$uploadFile.parents('.comp-qc-container').find('form');
            this.successModalId = this.$cqcForm.data('modalonsuccess');
            this.confirmModalId = this.$cqcForm.data('modalonconfirmation');
            this.formUid = this.$cqcForm.data('uid');
            _.bindAll(this, 'continueUpload', 'deleteFile');
            this.eventAgg.on(this.confirmModalId + 'continue', this.continueUpload, this);

            //order status
            this.orderStatusModel = new ws.models.quoteConversionOrderModel();
            this.validatePoModel = new ws.models.orderResellerPoValidateModel();
            this.$validationMsg = this.$('.po-validation-message');
            this.$validationInfo = this.$('.info');
            this.$pendingMessage = this.$('.cqc-pending-message');
            this.$formSubmittedMessage = this.$('.cqc-submitting-message');
            this.$stillWaitingMessage = this.$('.cqc-still-pending-message');
            this.orderStatusInterval = Number($.trim(this.$('.cqc-status-interval').html()));
            this.$saveButton.prop('disabled', false);
            ws.views.form.prototype.initialize.call(this);
        },

        /**
         * Check if user has FormData support
         */
        hasFormData: function () {
            return !!win.FormData;
        },

        /**
         * Verify file type
         */
        verifyFile: function () {
            var uploads = this.$('.upload')[0];
            uploads = _.toArray(uploads.files);

            if (this.hasFormData() === false) {
                // for <=IE9 we want to clear the list after each selection
                this.fileList = [];
            }

            this.$cqcErrors.hide();

            // add newly selected files to proxy array
            if (uploads.length) {
                _.each(uploads, function (file) {
                    if (this.cqcFileTypes.indexOf(file.type) === -1 || this.cqcExtensions.indexOf(file.name.split('.').pop().toLowerCase()) === -1) {
                        this.$fileUploadFormatError.show();
                    } else if (this.checkSameFileName(file.name)) {
                        this.$fileSameError.show();
                    } else {
                        this.fileList.push(file);
                        this.eventAgg.trigger(this.successModalId);
                    }
                }.bind(this));
            }

            // remove duplicate file entries
            this.fileList = _.uniq(this.fileList, 'name');

            if (this.fileList.length > 0) {
                this.renderFileList();
            }

            this.callGAEvents(this.GTM_EVENT_OPTIONAL_FILE_ACTION);
        },

        /**
         * Generic function to call 3 Google Analytics Actions for the Ecom Site
         */
        callGAEvents: function (eventAction) {
            if (this.$siteFromName === 'westcon') {
                this.gtmEventTracking(this.GTM_EVENT_CATEGORY, eventAction);
            }
        },

        /**
         * A helper to (re)render selected file list.
         */
        renderFileList: function () {
            // remove all previously rendered files and their corresponding event handlers
            this.$fileName.empty();

            //render a new file list
            this.$fileName.html(this.$uploadFileTpl({items: this.fileList, canDelete: this.hasFormData()}));
        },

        /**
         * Verify PO File Upload
         */
        verifyPOFileUpload: function () {
            var fileName = this.$uploadPOInput.files[0].name;
            var fileType = this.$uploadPOInput.files[0].type;
            var file = fileName.split('.');
            var fileExtension = file[file.length - 1].toLowerCase();
            var allowedType = this.cqcFileTypes;
            var allowedExtensions = this.cqcExtensions;

            this.$cqcPoErrors.hide();

            if (allowedType.indexOf(fileType) === -1 || allowedExtensions.indexOf(fileExtension) === -1) {
                var $container = this.$uploadFile.parents('.comp-qc-container');
                $container.find('form')[0].reset();
                this.$filePoFileTypeError.show();
                this.$poFileName.empty();
            } else if (this.checkSameFileName(fileName)) {
                this.$uploadPOInput.value = '';
                this.$filePoSameError.show();
            } else {
                this.uploadFile();

                // calling Google analytics function
                this.callGAEvents(this.GTM_EVENT_ACTION);
            }
        },

        /**
         * Check if the file of a given name has not already been uploaded
         * @param {string} name
         */
        checkSameFileName: function(name) {
            //check if fileList contains the file name
            var fileListHasName = this.fileList.filter(function(item) {
                return item.name === name;
            });

            //check if PO file is not of the same name
            var poHasName = this.$poFileName.text().indexOf(name) !== -1;

            return fileListHasName.length > 0 || poHasName;
        },

        /**
         * Upload PO file
         */
        uploadFile: function () {
            var fileName = this.$uploadPOInput.files[0].name;
            this.$uploadFile.parents('.comp-qc-container').find('.cqc-po-error').hide();
            this.$poFileName.html(fileName + '   <i class="icon-trash"></i>');
            this.eventAgg.trigger(this.successModalId);
        },

        /**
         * Confirm Upload
         * @param {Object} e
         */
        confirmUpload: function (e) {
            if (this.$uploadPOInput.files[0]) {
                e.preventDefault();
                this.eventAgg.trigger(this.confirmModalId);
            }
        },

        /**
         * Continue upload
         */
        continueUpload: function () {
            // reset file input
            this.$uploadPOInput.type = 'text';
            this.$uploadPOInput.type = 'file';
            this.$poFileName.empty();
            this.$uploadPOInput.click();
        },

        /**
         * Delete File by filtering the original filelist
         * @param {Object} e
         */
        deleteFile: function (e) {
            if ($(e.target).closest('.cqc-upload').length > 0) {
                var filename = $(e.target).data('filename');
                this.fileList = _.filter(this.fileList, function (item) {
                    return item.name !== filename;
                });

                if (this.fileList.length == 0) {
                    this.$uploadInput.value = '';
                }

                this.renderFileList();
            } else if ($(e.target).closest('.cqc-upload-po').length > 0) {
                this.$poFileName.empty();
                this.$uploadPOInput.value = '';
            }
        },

        /**
         * Override form submission to send a FormData including all selected files
         */
        submitForm: function () {

            if (this.formUid !== 'quoting') {
                if (!this.termsValidation()) {
                    this.$saveButton.removeClass('spinner-before').prop('disabled', false);
                    return false;
                }
            }

            // if FormData not present (for <=IE9) - do not do anything, just submit the form in a regular manner
            if (this.hasFormData()) {
                var fd = new FormData();

                fd.append('poNumber', this.$('[name=poNumber]').val());
                fd.append('quoteId', this.$('[name=quoteId]').val());
                fd.append('versionId', this.$('[name=versionId]').val());
                fd.append('sbaIds', this.$('[name=sbaIds]').val());
                fd.append('file', this.$uploadPOInput.files[0]);

                _.each(this.fileList, function (item) {
                    fd.append('otherFiles', item);
                });

                var submitForm = $.ajax({
                    type: 'POST',
                    url: this.$el.prop('action'),
                    data: fd,
                    processData: false,
                    contentType: false,
                    beforeSend: function () {
                        this.$saveButton.addClass('spinner-before').prop('disabled', true);
                    }.bind(this)
                });

                if (sitePath === '/quote') {
                    //if in quoting storefront
                    submitForm.done(function (data) {
                        this.$pendingMessage.removeClass('hide');
                        this.$formSubmittedMessage.show();

                        if (data) {
                            if (data.error) {
                                this.$globalMessage.html(data.error);
                                this.$globalMessage.show();
                            }

                            switch (data.status) {
                                case null:
                                case 'pending':
                                    this.$globalMessage.hide();

                                    // Order status model
                                    this.orderStatusModel.url = globals.path.api[this.uid].quoteConversionOrderStatus + this.$('input[name=quoteId]').val() + '/status';
                                    this.orderStatusModel.set({
                                        value: data.sapOrderId
                                    });
                                    this.getOrderStatus();

                                    break;
                                case 'submitted':
                                    this.$globalMessage.hide();
                                    this.redirectToConfirmationPage(data);
                                    break;
                            }
                        }

                    }.bind(this));
                } else {
                    // Old submit flow
                    // TODO: update when BE makes RS storefront changes
                    submitForm.done(function (data) {
                        this.$saveButton.removeClass('spinner-before').prop('disabled', false);

                        if (data) {
                            if (data.error) {
                                this.$globalMessage.show();
                                this.$globalMessage.html(data.error);
                                this.$saveButton.removeClass('spinner-before').prop('disabled', false);
                            }

                            if (data.code) {
                                this.$globalMessage.hide();
                                var orderNum = data.code + (data.sapOrderId ? '/' + data.sapOrderId : '');
                                win.location.replace(globals.path.api[this.uid].conversionConfirmation + orderNum);

                                // calling Google analytics function
                                this.callGAEvents(this.GTM_EVENT_SUBMIT_ORDER_ACTION);

                                //we should trigger adobe event from here
                                if (this.$siteFromName === 'westcon') {
                                    dataLayerAA.quote = {};
                                    dataLayerAA.quote.id = this.$('[name=quoteId]').val();
                                    dataLayerAA.order = {};
                                    dataLayerAA.order.purchaseNo = this.$('[name=poNumber]').val();
                                }

                            }
                        }
                    }.bind(this));
                }

                return false;
            }
        },

        /**
         * Get order status until success
         */
        getOrderStatus: function() {
            var timeElapsed = 0;
            var cloudOrderId;
            var cloudOrderError;

            var getOrderStatus = setInterval(function() {
                this.orderStatusModel.fetch().done(function(response) {

                    switch (response.status) {
                        case 'pending':
                            timeElapsed++;
                            if (timeElapsed === 4) {
                                this.$formSubmittedMessage.hide();
                                this.$stillWaitingMessage.show();
                            }

                            if (response.cloudOrderSubmitStatus == 'submitted') {
                                cloudOrderId = response.cloudOrderId;
                            }

                            if (response.cloudOrderSubmitStatus == 'error') {
                                cloudOrderError = response.cloudOrderError;
                            }

                            break;
                        case 'submitted':
                            clearInterval(getOrderStatus);
                            if (response.cloudOrderId != null) {
                                cloudOrderId = response.cloudOrderId;
                            }

                            if (response.cloudOrderError != null) {
                                cloudOrderError = response.cloudOrderError;
                            }

                            this.redirectToConfirmationPage(response, cloudOrderId, cloudOrderError);
                            break;
                        case 'error':
                            clearInterval(getOrderStatus);
                            if (cloudOrderId) {
                                this.$cloudOrderSuccess.show();
                                this.$cloudOrderSuccess.html(this.$cloudOrderSuccess.html().replace('{0}', cloudOrderId));
                            }

                            var errorMessage = (response.error) ? response.error : this.genericErrorMessage;
                            this.$globalMessage.show();
                            this.$globalMessage.html(errorMessage);
                            this.$pendingMessage.addClass('hide');
                            this.$formSubmittedMessage.hide();
                            this.$stillWaitingMessage.hide();
                            this.$saveButton.removeClass('spinner-before').prop('disabled', false);
                            break;
                    }
                }.bind(this));
            }.bind(this), this.orderStatusInterval);
        },

        /**
         * Redirect to order confirmation page.
         *
         * @param {Object} response - The response.
         * @param {string} response.code - The order number.
         * @param {string} response.sapOrderId - The SAP order ID.
         */
        redirectToConfirmationPage: function(response, cloudOrderId, cloudOrderError) {
            var orderNum;

            if (response.code != null) {
                orderNum = response.code;
            } else {
                orderNum = cloudOrderId;
            }

            // If we don't have an SAP order ID, pass "null" as the parameter in the path
            orderNum += '/' + (response.sapOrderId ? response.sapOrderId : 'null') + '?cloudOrderId=' + (cloudOrderId ? cloudOrderId : '') + '&cloudError=' + (cloudOrderError ? cloudOrderError : '');

            win.location.replace(globals.path.api[this.uid].conversionConfirmation + orderNum);
        },

        /**
         * A cross browser way of getting uploaded file name, since IE9 does not support `files` property on an input
         * type file
         */
        getFileName: function (input) {
            if (input.files) {
                return _.toArray(input.files);
            } else {
                return input.value.match(/[^\/\\]+$/);
            }
        },

        /**
         * Checkbox Terms and Conditions - toggle error and return boolean value telling if input is checked or not
         */
        termsValidation: function () {
            this.$termsError.toggle(!this.$checkTerms.is(':checked'));
            return this.$checkTerms.is(':checked');
        },

        /**
         * This function will show warning message if same PO Number is getting used by other offer.
         * @param {Event} e
         */
        validatePoNumber: function (e) {
            if (this.uid === 'quoting') {
                this.validatePoModel.set({
                    poNumber:  e.currentTarget.value,
                    silent: true
                });
                this.validatePoModel.fetch({
                    success: this.setPoWarningMessage.bind(this),
                    error: this.validatePoError.bind(this)
                });
            }
        },

        /**
         * This method will show PO Number warning if PO Number is already in use
         * @param {Object} data
         */
        setPoWarningMessage: function (data) {
            if (data.get('hasError') === true) {
                this.$validationMsg.text(data.get('error'));
                this.$validationInfo.removeClass('hide');
            } else {
                this.$validationInfo.addClass('hide');
                this.$validationMsg.text('');
            }
        },

        /**
         * This method will get called in case of error in validate PO Number.
         * @param {Object} error
         */
        validatePoError: function (error) {
            console.error('Error in Validating PO Number', error);
            this.$validationMsg.text('Error in Validating PO Number');
            this.$validationInfo.removeClass('hide');
        }

    });
})(westcon, window);
